'use strict';

import { Offcanvas, Dropdown } from 'bootstrap';
import FocusTrap from 'bootstrap/js/src/util/focustrap.js';
import TPSAzureSuggester from "../../tps-azuresuggester/dist/index";

export default class OPLHeader {
    constructor() {
        this.headerElem = document.getElementById('site-header');
        this.mobileMenu = document.getElementById('site-menu-mobile');
        this.headerDropdownTriggers = document.querySelectorAll('#site-header [data-bs-toggle="dropdown"]');
        this.headerDropdownSearchTrigger = document.getElementById('searchdrop-trigger');
        this.bsOffcanvas = null;
        this.lgQuery = window.matchMedia(`(min-width: ${window.getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg')})`);
        this.searchInputs = document.querySelectorAll('.opl-header-search-form-input');
    }

    init() {
        if (this.mobileMenu) {
            this.initMobileMenu();
        }
        this.initSearchAutocomplete();
    }

    initMobileMenu() {
        const self = this;

        // Custom focus trap on Bootstrap Offcanvas because we need to include other header elements too. 
        self.bsOffcanvas = new Offcanvas(self.mobileMenu);
        if (self.headerElem) {
            self.bsOffcanvas._focustrap = new FocusTrap({
                trapElement: self.headerElem
            });
        }

        // The offcanvas and search dropdown should be hidden on larger views
        if (self.headerDropdownSearchTrigger) {
            const searchDropdown = Dropdown.getOrCreateInstance(self.headerDropdownSearchTrigger);

            self.lgQuery.addEventListener('change', () => {
                if (self.lgQuery.matches) {
                    self.bsOffcanvas.hide();
                    searchDropdown.hide();
                }
            });
        }

        // Close the offcanvas when dropdowns are open
        if (self.headerDropdownTriggers) {
            self.headerDropdownTriggers.forEach(dropdown => {
                dropdown.addEventListener('show.bs.dropdown', () => {
                    self.bsOffcanvas.hide();
                });
            });

            // if any dropdowns are shown on resize, update their positions
            window.addEventListener('resize', window.OPL.Utility.debounce(() => {
                self.headerDropdownTriggers.forEach(dropdown => {
                    if (dropdown.getAttribute('aria-expanded') === 'true') {
                        const bsDropdown = Dropdown.getOrCreateInstance(dropdown);
                        bsDropdown.update();
                    }
                });
            }, 200));
        }
    }

    initSearchAutocomplete() {
        this.searchInputs.forEach(input => {
            const azSuggester = new TPSAzureSuggester(input, {
                suggestions: {
                    onSelect: (event, optionItem, val) => {
                        const form = input.closest('form');
                        input.value = val; // the value might be stale, update.
                        form.submit();
                    }
                }
            });
            azSuggester.init();
        });
    }
}
